import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material';

@Component({
  selector: 'igo-poi-dialog',
  template: require('./poi-dialog.component.html'),
})
export class PoiDialogComponent {

  public title: string;

  constructor(public dialogRef: MatDialogRef<PoiDialogComponent>) {}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/map/poi-button/poi-dialog.component.ts